export default "__VITE_ASSET__7604615c__"